import Mobile from './Mobile'
import withDevice from '../withDevice'

export default withDevice(Mobile)
